var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vs-error-page" },
    [
      _c(
        "vs-layout",
        {
          staticClass: "vs-error-page__header bg-brand",
          attrs: {
            "horz-align-center-xs": "horz-align-center-xs",
            "vert-align-center-xs": "vert-align-center-xs",
            "col-xs": "col-xs"
          }
        },
        [
          _vm.heading
            ? _c("h1", { staticClass: "text-4xl tracking-normal" }, [
                _vm._v(_vm._s(_vm.heading))
              ])
            : _vm._e(),
          _vm.subHeading
            ? _c("h3", { staticClass: "text-xl tracking-normal" }, [
                _vm._v(_vm._s(_vm.subHeading))
              ])
            : _vm._e()
        ]
      ),
      _c(
        "vs-layout",
        {
          staticClass: "vs-error-page__body",
          attrs: {
            "wrap-xs": "wrap-xs",
            "horz-align-center-xs": "horz-align-center-xs",
            "vert-align-center-xs": "vert-align-center-xs"
          }
        },
        [
          _c(
            "div",
            [
              _vm.message
                ? _c("h5", { staticClass: "text-lg tracking-normal" }, [
                    _vm._v(_vm._s(_vm.message))
                  ])
                : _vm._e(),
              _vm.showBackButton
                ? _c("vs-button", {
                    staticClass:
                      "bg-brand text-white px-1_25 py-_75 uppercase hover_bg-brand-900",
                    attrs: { text: "Go Back" },
                    on: { click: _vm.handleGoBack }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }